<ng-template [ngIf]="fascicolo && descrittori">
<li class="panel">

	<ul class="collapse in" id="subpratica1">
		<li>
			<div
				class="{{'subpratica ' +getCssClassCategoriaFascicolo (fascicolo)}}">
				<div [ngStyle]="{ 'margin-bottom' : ( fascicolo?.numeroProtocollo ? '4px' : '0px') }">
					<p
						class="{{'categoria ' + fascicolo.intestazione.campi.tipoFascicolo.toLowerCase()}}">{{
						fascicolo.intestazione.campi.tipoFascicolo}}</p>
					<p class="codice" style="margin-bottom:5px">{{ fascicolo.intestazione.campi.posizione }}</p>
					<p class="codice" *ngIf="fascicolo.numeroProtocollo">{{fascicolo.numeroProtocollo}}</p>
					<!-- <p class="codice" *ngIf="fascicolo.numeroFascicoloProtocollo">Fasc.{{fascicolo?.numeroFascicoloProtocollo}}</p> -->
        		</div>
				<div>
					<p class="identificativo">
						{{fascicolo?.intestazione.campi.numeroRuolo ? 'N. ruolo' :''}}
						<strong>{{fascicolo?.intestazione.campi.numeroRuolo ?	fascicolo?.intestazione.campi.numeroRuolo+' ' :''}} </strong>
						{{fascicolo?.intestazione.campi.annoRuolo && fascicolo?.intestazione.campi.numeroRuolo ? '-' :''}}
						{{fascicolo?.intestazione.campi.annoRuolo ? 'A. ruolo' :''}}
						<strong>{{fascicolo?.intestazione.campi.annoRuolo ?	fascicolo?.intestazione.campi.annoRuolo+' ' :' '}} </strong>
						{{ fascicolo?.intestazione.campi.annoRuolo || fascicolo?.intestazione.campi.numeroRuolo ? '&nbsp;' : '' }}
						{{ 'DEL ' + (fascicolo.intestazione.campi.dataInizioFascicolo |
						date:'dd/MM/yyyy') }} {{ fascicolo.intestazione.campi.definito ? '
						- DEFINITA IL ' + (fascicolo.intestazione.campi.dataDefinizione |
						date:'dd/MM/yyyy') : '' }}
						{{(fascicolo.intestazione.campi.tipoRicorso) ? (' - '+fascicolo.intestazione.campi.tipoRicorso) : ''}}
						{{(fascicolo.intestazione.campi.tipoOpposizione) ? (' - '+fascicolo.intestazione.campi.tipoOpposizione) : ''}}
						<span
							*ngIf="fascicolo.intestazione.campi.definito" title="Definito"
							class="glyphicon glyphicon-lock"></span> <span
							*ngIf="fascicolo.intestazione.campi.capofila"
							title="Capofila riunione di giudizi"
							class="riunionegiudizi glyphicon glyphicon-resize-small"><span
							class="glyphicon capofila">C</span></span> <span
							*ngIf="fascicolo.intestazione.campi.riunito"
							title="Riunione di giudizi"
							class="glyphicon glyphicon-resize-small"></span> <span
							*ngIf="fascicolo.stato.id === archiviatoId" title="Archiviato"
							class="glyphicon glyphicon-floppy-saved"></span>
							<span *ngIf="fascicolo.intestazione.campi.isDocumentazione" class="glyphicon glyphicon-file" title="Documenti allegati"></span>
					</p>
					<div class="titolo">{{
						fascicolo.intestazione.campi.contropartePrimaria ?
						fascicolo.intestazione.campi.contropartePrimaria :
						"Nessun soggetto/parte specificato " }}
            			<ng-container> {{
                			fascicolo.intestazione.campi.grado ?
                   			" - " + fascicolo.intestazione.campi.grado : "" }}
						</ng-container>
						{{fascicolo?.intestazione.campi.natura ? " - " +
						fascicolo?.intestazione.campi.natura : ""}}
          			</div>
				</div>
			</div>
			<div class="data_opzioni fasi" *ngIf="showOpzioni">
				<ul>
					<li class="opzioni" appDropdownFocus><a class="dropdown-toggle"
						data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
						aria-expanded="false">Opzioni<span
							class="glyphicon glyphicon-option-vertical"></span></a>
						<div class="dropdown-menu">
							<ul option-fascicolo [fascicolo]="fascicolo" [pratica]="fascicolo?.praticaBase" [descrittori]="descrittoriFascicoloMap"
									(onReturnMethodFascicoloOption)="runMethodFascicoloOption($event.method, $event.fascicolo, $event.pratica)">
									</ul>
						</div></li>
				</ul>
			</div>

		</li>

	</ul>
</li>
</ng-template>


<div class="modal fade" id="modalRiunisciGiudizi" tabindex="-1"
	role="dialog" style="display: none;"
	(onReturn)="recallFascicolo($event)"
	riunisci-giudizi #modalRiunisciGiudizi></div>

<div class="modal fade" id="modaldefinisciFascicolo" tabindex="-1"
	role="dialog" style="display: none;"
	(onReturn)="recallFascicolo($event)"
	fascicolo-definisci-modal #fascicoloDefinisciModal></div>

<div class="modal fade" id="modalInviaNotifica" tabindex="-1"
	role="dialog" style="display: none;"
	(onReturn)="recallFascicolo($event)"
	invia-notifica-modal #inviaNotificaModal></div>

<div class="modal bigmodal fade in" id="modaldepositoPCT" tabindex="-1"
	role="dialog" style="display: none" deposito-pct #depositoPct></div>

<div class="modal fade" id="modalCopyFascicoloIntestazione" tabindex="-1" role="dialog"
     style="display: none;"
     fascicolo-select-modal #fascicoloSelectModal></div>
